(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function (e) {
  const authForm = document.getElementById('cover101-auth-form');
  let submitButton = authForm.querySelector('[name="fdsa-login-submit"]');
  let existingContent = submitButton.innerHTML;
  if (typeof authForm != 'undefined' && authForm != null) {
    const authContainer = document.getElementById('cover101-auth-container'),
      status = authForm.querySelector('[data-message="status"]');
    authForm.addEventListener('submit', e => {
      e.preventDefault();
      resetMessages();
      let data = {
        name: authForm.querySelector('[name="username"]').value,
        password: authForm.querySelector('[name="password"]').value,
        nonce: authForm.querySelector('[name="cover101_auth"]').value
      };
      if (!data.name || !data.password) {
        status.innerHTML = "Username and Password are required";
        status.classList.add('error');
        return;
      }
      let url = authForm.dataset.url;
      let params = new URLSearchParams(new FormData(authForm));

      // Update the button text and disable it

      submitButton.textContent = "Logging in...";
      submitButton.disabled = true;

      // authForm.querySelector('[name="submit"]').value = "Logging in...";
      // authForm.querySelector('[name="submit"]').disabled = true;

      fetch(url, {
        method: "POST",
        body: params
      }).then(res => res.json()).catch(error => {
        resetMessages();
      }).then(response => {
        resetMessages();
        if (response === 0 || !response.status) {
          status.innerHTML = response.message;
          status.classList.add('error');
          return;
        }
        status.innerHTML = response.message;
        status.classList.add('success');
        authForm.reset();
        window.location.href = baseUrl ? baseUrl + '/dashboard' : '/dashboard';
      });
    });
    function resetMessages() {
      status.innerHTML = '';
      status.classList.remove('success', 'error');
      submitButton.innerHTML = existingContent;
      submitButton.disabled = false;
    }
  }
});

},{}]},{},[1]);
